import { render, staticRenderFns } from "./EnergySector.vue?vue&type=template&id=7076d9cf&scoped=true&"
import script from "./EnergySector.vue?vue&type=script&lang=js&"
export * from "./EnergySector.vue?vue&type=script&lang=js&"
import style0 from "./EnergySector.vue?vue&type=style&index=0&id=7076d9cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7076d9cf",
  null
  
)

export default component.exports